import axios from 'axios'
import { getCookie } from '../util'

axios.defaults.baseURL = window._env_.REACT_APP_BROKER_API_URL
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'

if (window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken')
  axios.defaults.headers.common['kxToken'] = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
else
  axios.defaults.headers.common['kxToken'] = getCookie('kxBrokerToken')

axios.defaults.method = 'post'

const custom = (config = {}) => {
  config.url=axios.defaults.baseURL+ "?axd="+config.data.eventType;
  return axios(config)
}

const post = data => {
  let config = {}
  config.data = data
  return axios(config)
}

const get = (url = '', data = '', config = {}) => {
  config.params = data
  config.method = 'get'
  return axios.get(url, config)
}

const put = (url = '', data = '', config = {}) => {
  return axios.put(url, data, config)
}

const del = (url = '', config = {}) => {
  return axios.delete(url, config)
}


//Save the cancel token for the current request

const cancelRequest = () => {
  let cancelToken = axios.CancelToken.source()

  //Check if there are any previous pending requests
  if (typeof cancelToken != typeof undefined) {
    cancelToken.cancel("Operation canceled due to new request.")
  }
}

const HttpClient = {
  custom,
  post,
  get,
  put,
  delete: del,
  cancelRequest
}

export { HttpClient }
